import { Activity, ActivityRegistrationStatus } from '../../../pure-js/types/GrooverTypes'

export type RegistrationRoleRestrictions = {
  leadersClosed: boolean
  followersClosed: boolean
}

export const getRoleRestrictionsForActivity = (activity?: Activity): RegistrationRoleRestrictions => {
  const registrationStatus = activity?.registrationStatus

  return {
    leadersClosed: registrationStatus === ActivityRegistrationStatus.ClosedForLeaders,
    followersClosed: registrationStatus === ActivityRegistrationStatus.ClosedForFollowers
  }
}
